import React from "react";
import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import SageScreen from "kit/SageScreen";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import { minutesToString } from "utils/minutesFormat";
import { useDispatch, useSelector } from "react-redux";
import createSaleStatusSelector from "selectors/createSaleStatus";
import { setCreateSaleStatus } from "actions/balance";
import BalanceMinutesSellForm from "./balanceMinutesSell/BalanceMinutesSellForm";
import BalanceMinutesSellSuccess from "./balanceMinutesSell/BalanceMinutesSellSuccess";

const BalanceMinutesSell: React.FC = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setCreateSaleStatus("none"));
    }, [dispatch]);

    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const createSaleStatus = useSelector(createSaleStatusSelector);

    return (
        <SageScreen>
            <h2>Sell Minutes</h2>
            <p>
                Your Current Balance:{" "}
                {user ? (
                    <span className="text-primary">
                        {minutesToString(user.minutes_balance)}
                    </span>
                ) : (
                    "loading"
                )}
            </p>
            {createSaleStatus === "success" ? (
                <BalanceMinutesSellSuccess />
            ) : (
                <BalanceMinutesSellForm />
            )}
        </SageScreen>
    );
};

export default BalanceMinutesSell;
